import DS from 'ember-data';
import TourValidations from '../validators/tour';
import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';
import { filterBy, or } from '@ember/object/computed';
export default DS.Model.extend(TourValidations, {
  title: DS.attr('string'),
  url: DS.attr('string'),
  insertable: DS.attr('boolean'),
  insertableUrl: DS.attr('string'),
  description: DS.attr('string'),
  endTourAnimation: DS.attr('string'),
  buttonColor: DS.attr('string'),
  backgroundColor: DS.attr('string'),
  customHeaderText: DS.attr('string'),
  customFont: DS.attr('string'),
  restartable: DS.attr('boolean'),
  restartButtonText: DS.attr('string'),
  snoozeable: DS.attr('boolean'),
  snoozeButtonText: DS.attr('string'),
  steps: DS.hasMany('tour-step'),
  hasSteps: computed('steps.[]', function () {
    return isPresent(this.steps);
  }),
  hasClickToProgressSteps: computed('steps.[]', function () {
    return this.steps.any(step => step.isClickToProgress);
  }),
  pointerSteps: filterBy('steps', 'isPointer'),
  senderType: DS.attr('string'),
  fallbackTitle: 'Untitled tour',
  displayedTitle: or('title', 'fallbackTitle')
});